import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SharedForm from "@widgets/SharedForm";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import SnResizableLNR from "@shared/components/SnResizableLNR";
import SnGrid from "@shared/components/Grid/SnGrid";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const SN_SCT_BAS_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  // state
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any[]>([]);
  const [sharedForm, setSharedForm] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any>();
  const [focusedRowData, setFocusedRowData] = useState<any>();

  // ref
  const searchRef = useRef<any>(null);
  const gridref1 = useRef<any>(null);
  const SharedFormref1 = useRef<any>();

  // golbal variable
  const { userInfo } = global();

  //#region grid 길이 관련
  let width1 = "49.5%";
  let width2 = "49.5%";
  const menuSize = localStorage.getItem("menuSize");
  if (menuSize) {
    const menu = JSON.parse(menuSize);
    if (menu.SN_SCT_BAS_REG_001) {
      width1 = menu.SN_SCT_BAS_REG_001.grid1Width
        ? menu.SN_SCT_BAS_REG_001.grid1Width
        : width1;
      width2 = menu.SN_SCT_BAS_REG_001.grid2Width
        ? menu.SN_SCT_BAS_REG_001.grid2Width
        : width2;
    }
  }
  const [grid1Width, setGrid1Width] = useState<string | number>(width1);
  const [grid2Width, setGrid2Width] = useState<string | number>(width2);
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setSharedForm(rtn.form.freeform1);
        setColums(rtn.grid.grid1);
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    const modifiedRowsH = gridref1.current.getChange();
    if (modifiedRowsH.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      const params = {
        id: "sn_sct_bas_reg_001_01",
        params: searchRef.current.getFormdata(),
      };

      setDataSource1([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));
        gridref1.current?.selectAndFocusRow(0);
      }
      gridref1.current.resetUpdate();
    } catch (error) {}
  };

  const onInsert = async () => {
    const newRow = {};
    if (gridref1.current) {
      gridref1.current.addRow(newRow);

      setTimeout(() => {
        const api = gridref1.current?.api;

        const focusedCellH = api.getFocusedCell();

        if (api) {
          api.ensureIndexVisible(focusedCellH.rowIndex);
          api.setFocusedCell(focusedCellH.rowIndex, "cd_sct");
          api.getDisplayedRowAtIndex(focusedCellH.rowIndex)?.setSelected(true);
        }
      }, 50);
    }
  };

  const onBeforeAddRowH = (newRow: RowData): boolean => {
    try {
      const selectedFormData = searchRef.current.getFormdata();
      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: selectedFormData.cd_biz_param,
        yn_use: "Y",
        yn_app: "N",
        fg_trns: "1",
      };
      Object.assign(newRow, updatedRow); // 원본 객체 수정

      return true;
    } catch (error: any) {
      return false;
    }
  };

  const onDelete = async () => {
    try {
      gridref1.current?.deleteSelectedRows();
    } catch (error: any) {
      throw error;
    }
  };

  const onSave = async () => {
    let SaveData: any = {};
    try {
      const requiredValuesCheckH = gridref1.current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }

      const changesRow = gridref1.current.getChange();
      if (changesRow.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const hasInvalidCdSct = [
        ...(changesRow.insert || []),
        ...(changesRow.update || []),
      ].some((item) => item.cd_sct && item.cd_sct.length > 6);

      if (hasInvalidCdSct) {
        await showDialog("alter", "외주형태코드가 6자리를 초과하였습니다.");
        return;
      }
      SaveData["mas_sctype"] = gridref1.current.getChange();
      await fnSave("SN_SCT_BAS_REG_001_SAVE_01", SaveData);
      gridref1.current.resetUpdate();
    } catch (error: any) {}
  };

  const onFocusedRowChanged = useCallback(
    (focusedRowData: any | null) => {
      setFocusedRowData(focusedRowData || null);
    },
    [focusedRowData]
  );

  // grid1의 width resize
  const onResizeStopH = (width: number) => {
    setGrid1Width(width);
  };

  // grid2의 width resize
  const onResizeStopL = (width: any) => {
    setGrid2Width(width);
  };

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  //region UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="w-full flex flex-row space-x-2 flex-grow overflow-x-auto">
        <SnResizableLNR
          width={grid1Width}
          minWidth={130}
          onResizeStop={onResizeStopH}
          enable={{ right: true }}
          menuName={Menuprops.cd_menu || "SN_SCT_BAS_REG_001"}
          defaultSize={{ grid2Width: grid2Width }}
        >
          <SnGrid
            seq={1}
            ref={gridref1}
            
            enableAddRow={true}
            columnConfig={columns} // 컬럼 설정 전달
            rowData={dataSource1}
            enableExternalChart={false}
            isEditable={false}
            rowSelection="single" // 단일 선택 모드
            onFocusedRowChanged={onFocusedRowChanged}
            onBeforeAddRow={onBeforeAddRowH}
            title="외주형태"
          />
        </SnResizableLNR>
        <SnResizableLNR
          width={grid2Width}
          minWidth={130}
          onResizeStop={onResizeStopL}
          enable={{ right: true }}
          menuName={Menuprops.cd_menu || "SN_SCT_BAS_REG_001"}
          defaultSize={{ grid1Width: grid1Width }}
        >
          <SharedForm
            ref={SharedFormref1}
            data={focusedRowData}
            controls={sharedForm}
            gridref={gridref1}
            
            title="상세정보"
          ></SharedForm>
        </SnResizableLNR>
      </div>
    </div>
  );
});

export default SN_SCT_BAS_REG_001;
